<script>
export default {
  name: "custom-message",
  data: function() {
    return {};
  },
  methods: {
    onModalClose: function() {
      this.$store.commit("clearMessage");
    },
  },
  computed: {
    content: function() {
      return this.$store.state.messageContent ? this.$store.state.messageContent : "";
    },
    title: function() {
      return this.$store.state.messageTitle ? this.$store.state.messageTitle : "";
    },
    messageType: function() {
      return this.$store.state.messageType ? this.$store.state.messageType : "";
    },
    messageVisible: function() {
      return this.$store.state.messageBoxVisible;
    },
    renderHtml: function() {
      return this.$store.state.messageHtml;
    },
  },
};
</script>
<template>
  <div>
    <b-modal id="custom-message-modal" :title="title" v-model="messageVisible" :class="`${messageType}-modal`" v-on:hidden="onModalClose">
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;" v-if="!renderHtml">
            {{ content }}
          </div>
          <div style="padding:5px;" v-else v-html="content"></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
